<template>
  <div :class="$style.container">
    <slot />
  </div>
</template>

<script>
export default {

}
</script>

/// #if PLATFORM === 'xd'
<style lang="scss" module>
.container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;

  :global {
    .container {
      height: 100%;
      max-width: 180px;
      flex-direction: column;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .title {
      font-size: 16px;
      font-weight: $font-weight-bold;
      margin-bottom: 10px;
      color: $typo-light-1;
      line-height: 1.2;
    }
    .description {
      font-size: 12px;
      color: $typo-light-2;
      margin-bottom: 40px;
      line-height: 1.2;
    }
    .image {
      display: inline-block;
      margin-bottom: 30px;
      width: 180px;
    }
  }
}
</style>
/// #else
<style lang="scss" module>
.container {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
  background-color: var(--bg-3);
  z-index: $zindex-tooltip;

  :global {
    .container {
      height: 100%;
      flex-direction: column;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btn-icon {
      padding: 4px !important;
      width: auto !important;
      // width: 40px !important;
      // height: 40px;
    }
    .btn {
      border-radius: 50px;
      transition: none !important;
    }
    .title {
      font-size: 14px;
      line-height: $h3-line-height;
      font-weight: $font-weight-bold;
      margin-bottom: 10px;
      color: var(--typo-1);
      max-width: 200px;
    }
    .description {
      font-size: $font-size-sm;
      color: var(--typo-2);
      margin-bottom: 0;
      max-width: 240px;
    }
    .image {
      display: inline-block;
      margin-bottom: 0;
      width: 280px;
      max-width: 100%;
    }
  }
}
</style>
/// #endif
